import Modal from "antd/lib/modal/Modal";
import { Field, Form, Formik } from "formik";
import "./profileForm.scss";
import React, { FC, useEffect, useRef, useState } from "react";

import moment from "moment";
import InputField from "../../InputField";
import DropdownField from "../../DropdownField";
import DatePickerField from "../../DatePickerField";
import { DatePicker } from "antd";
import ButtonComponent from "../../ButtonComponent";
import ProfileDisplayPicture from "./ProfileDisplayPicture";

interface ProfileFormProps {
  data: any;
  closeHandler: () => void;
  visible: boolean;
}
const ProfileForm: FC<ProfileFormProps> = ({ visible, closeHandler, data }) => {
  const formRef = useRef<any>();

  useEffect(() => {
    setInitialValues({
      firstName: data?.firstName,
      lastName: data?.lastName,
      email: data?.email,
      phoneNumber: data?.phoneNumber,
      dateOfBirth: data?.dateOfBirth,
      gender: data?.gender,
      qualification: data?.qualification,
      displayPictureUrl: data?.displayPictureUrl,
    });
  }, [data]);

  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState<any>({
    firstName: null,
    lastName: null,
    email: null,
    phoneNumber: null,
    dateOfBirth: null,
    gender: null,
    qualification: null,
    displayPictureUrl: null,
  });
  const handleClose = () => {
    closeHandler();
    formRef.current.resetForm(initialValues);
  };
  const handleSubmit = (values: any) => {};
  return (
    <Modal
      title={null}
      centered
      visible={visible}
      onCancel={closeHandler}
      footer={null}
      className="profile-form__modal"
    >
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize
        innerRef={formRef}
      >
        {({ setFieldValue, values, resetForm }) => {
          return (
            <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
              <div className="profile-form__header">
                <div className="profile-form__title">Edit Profile</div>
              </div>

              <ProfileDisplayPicture defaultValue={values?.displayPictureUrl} />

              <div className="profile-form__input">
                <div className="profile-form__label">First Name</div>
                <InputField
                  type="text"
                  name="firstName"
                  placeholder="Type your first name"
                />
              </div>
              <div className="profile-form__input">
                <div className="profile-form__label">Last Name</div>
                <InputField
                  type="text"
                  name="lastName"
                  placeholder="Type your last name"
                />
              </div>
              <div className="profile-form__input">
                <div className="profile-form__label">Email</div>
                <InputField
                  type="text"
                  name="email"
                  placeholder="Type your email ID"
                />
              </div>
              <div className="profile-form__input">
                <div className="profile-form__label">Phone</div>
                <InputField
                  type="text"
                  prefix={"+91"}
                  name="phoneNumber"
                  placeholder="Type your phone number"
                />
              </div>

              <div className="profile-form__action">
                <div
                  className="profile-form__button"
                  onClick={() => {
                    handleClose();
                    resetForm({});
                  }}
                >
                  <ButtonComponent buttonContent="Cancel" type="text" />
                </div>
                <div className="profile-form__button">
                  <ButtonComponent
                    buttonContent={"Update"}
                    type="primary"
                    htmlType="submit"
                    loading={buttonLoading}
                  />
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};
export default ProfileForm;
